import { useNavigate, Link } from 'react-router-dom';
import { ArrowLeftIcon, ArrowRightOnRectangleIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../../../core/providers/AuthProvider';

function UserProfilePage() {
  const navigate = useNavigate();
  const { signOut } = useAuth();

  const handleClose = async () => {
    await signOut();
    navigate('/', { replace: true });
  };

  return (
    <div className="min-h-dvh w-screen bg-white flex flex-col">
      <header className="w-full shrink-0 h-20 bg-[#0b4a71] border-b border-gray-200 px-4 flex items-center gap-3">
        <button
          type="button"
          onClick={() => navigate(-1)}
          aria-label="Go back"
          className="text-white/80 hover:text-white"
        >
          <ArrowLeftIcon className="h-6 w-6" />
        </button>
        <h1 className="text-xl font-semibold text-white">Profile</h1>
      </header>

      <nav className="divide-y divide-gray-100">
        <Link
          to="/"
          className="flex items-center gap-3 px-4 py-4 text-[#0b4a71] hover:bg-gray-50"
        >
          <ArrowRightOnRectangleIcon className="h-6 w-6" />
          <span className="flex-1 text-lg font-medium">Login</span>
          <ChevronRightIcon className="h-5 w-5 text-gray-400" />
        </Link>
      </nav>

      <div className="mt-auto p-4">
        <button
          type="button"
          onClick={handleClose}
          className="w-full rounded-md bg-[#4ea6d0] py-4 text-lg font-medium text-white hover:bg-[#0b4a71]"
        >
          Close
        </button>
      </div>
    </div>
  );
}

export default UserProfilePage;
